import { gql } from "@grandvisionhq/graphql";
const SUBSCRIBE_NEWSLETTER = gql`
  mutation SubscribeNewsletter($input: SubscribeNewsletterInput!) {
    subscribeNewsletter(input: $input) {
      __typename
      success
      failures {
        ... on Failure {
          __typename
          message
        }
        ... on SubscribeNewsletterInputFailure {
          __typename
          message
        }
        ... on MandateUserNotFound {
          __typename
          message
        }
        ... on MandateValidationFailure {
          __typename
          message
        }
        ... on MandateGeneralFailure {
          __typename
          message
        }
      }
    }
  }
`;
export {
  SUBSCRIBE_NEWSLETTER
};
//# sourceMappingURL=subscribe-newsletter.js.map
